import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.containers.Checklist.ExternalArea.CondoName.title',
    defaultMessage: 'Esse é o nome do condomínio?',
  },
  label: {
    id: 'app.containers.Checklist.ExternalArea.CondoName.label',
    defaultMessage: 'Qual o nome do condomínio?',
  },
  yes: {
    id: 'app.containers.Checklist.ExternalArea.CondoName.yes',
    defaultMessage: 'Sim',
  },
  no: {
    id: 'app.containers.Checklist.ExternalArea.CondoName.no',
    defaultMessage: 'Não',
  },
  iDoNotKnowTheName: {
    id: 'app.containers.Checklist.ExternalArea.CondoName.iDoNotKnowTheName',
    defaultMessage: 'Não sei o nome',
  },
  condoName: {
    id: 'app.containers.Checklist.ExternalArea.CondoName.condoName',
    defaultMessage: 'Condomínio {condoName}',
  },
  condoAddress: {
    id: 'app.containers.Checklist.ExternalArea.CondoName.condoAddress',
    defaultMessage: '{address}, {number} - {neighborhood} {br} {state}',
  },
  placeholder: {
    id: 'app.containers.Checklist.ExternalArea.CondoName.placeholder',
    defaultMessage: 'Digite o nome do condomínio',
  },
  invalid: {
    id: 'app.containers.Checklist.ExternalArea.CondoName.invalid',
    defaultMessage: 'Campo obrigatório',
  },
  invalidNames: {
    id: 'app.containers.Checklist.ExternalArea.CondoName.invalidNames',
    defaultMessage: 'Nome inválido',
  },
});
